import {
  IconWrapper,
  IStyles,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
const styles: IStyles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-around',
    boxSizing: 'border-box',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    // my: { xs: pxToRem(10), md: pxTovW(10) },
    paddingTop: { xs: pxToRem(10), md: pxTovW(0) },
  },
};
interface IBloomLevel {
  title: string;
  Questions: number;
  color: string;
}
interface IProps {
  bloomLevelData: IBloomLevel[];
  editClickHandler?: () => void;
}
export const BloomLevelComponent = (props: IProps) => {
  const { bloomLevelData, editClickHandler } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant={isMobile ? 'h2' : 'h3'} fontWeight="bold">
          Bloom Level
        </Typography>

        {editClickHandler && (
          <Button sx={{ p: '0' }} onClick={editClickHandler}>
            <IconWrapper
              name="edit"
              type="png"
              parentFolder="icons"
              size="large"
            />
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          borderRadius: pxTovW(4),
          width: '100%',
        }}
      >
        {bloomLevelData.map((elem, index) => {
          const questionCount = parseInt(elem.Questions.toFixed(0), 10);
          if (questionCount === 0) return null;
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: 'max-content',
                // height: '100%',
                backgroundColor: elem.color,
                justifyContent: 'center',
                alignItems: 'center',
                gap: { xs: pxToRem(5), md: pxTovW(5) },
                paddingY: { xs: pxToRem(10), md: pxTovW(10) },
                paddingX: { xs: pxToRem(10), md: pxTovW(10) },
                flexGrow: 1,
              }}
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{ color: 'white' }}
              >
                {elem.Questions.toFixed(0)}%
              </Typography>
              <Typography variant="smallText" sx={{ color: 'white' }}>
                {elem.title}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const BloomLeveldata = [
  {
    title: 'Retention',
    Questions: 3,
    color: '#005DAA',
  },
  {
    title: 'Analysis',
    Questions: 1,
    color: '#F1A33B',
  },
  {
    title: 'Application',
    Questions: 2,
    color: '#009383',
  },
  {
    title: 'Comprehension',
    Questions: 4,
    color: '#5DC152',
  },
];
